export default __webpack_public_path__ + "static/media/accordous.f2d4682d.png";